import { Column } from "components/Table/Simple";
import { formatDateTime } from "components/Table/Simple/presets";

export const columns: Column[] = [
    {
        field: 'id',
        label: '카테고리 번호',
    },
    {
        field: 'name',
        label: '카테고리 이름',
        creatable: true,
        editable: true
    },
    {
        field: 'created_at',
        label: '생성일',
        render: formatDateTime
    },
    {
        field: 'updated_at',
        label: '수정일',
        render: formatDateTime
    }
]